export default "__VITE_ASSET__9153304a__"